var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 13.7826c0 .6696-.6 1.2174-1.3333 1.2174h-7.33337c-.73333 0-1.33333-.5478-1.33333-1.2174v-11.56521c0-.66956.6-1.21739 1.33333-1.21739h7.33337c.7333 0 1.3333.54783 1.3333 1.21739z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 10.5h-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 3.5h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 12.5h3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.89f775177740ae857e8e1807e3fd91a3.svg";
export { ForwardRef as ReactComponent };